export const ERROR_STATUS_CODES_TO_IGNORE = new Set<number>([
  400, 401, 404, 502, 503,
] as const);
